import React, { FC, useRef } from 'react';
import { Journey } from 'src/common/interfaces/journey.interface';
import { functionNoop } from 'src/utils/function/noop';
import { JourneyMenu } from 'src/common/JourneyMenu';
import { generateJourneyAliasShareUrl } from 'src/utils/journey';
import { useCurrentOrganization } from 'src/store/organization';

import { PreviewRegularIcon } from 'src/monet/icons';
import { useSharePanelStore } from 'src/common/store/share.store';

interface DashboardHomeJourneysPreviewLinksMenuProps {
  journey: Journey;
  renderMenuOrigin: (onClick: any) => any;
  onOpen: () => void;
  onClose: () => void;
}

export const DashboardHomeJourneysPreviewLinksMenu: FC<DashboardHomeJourneysPreviewLinksMenuProps> = ({
  journey,
  renderMenuOrigin,
  onOpen,
  onClose,
}) => {
  const { currentOrganization } = useCurrentOrganization();
  const onJourneyShareOpen = useSharePanelStore((state) => state.onJourneyShareOpen);

  const menuOpenRef = useRef(functionNoop);
  const menuCloseRef = useRef(functionNoop);

  const onMenuClicked = (e: any) => {
    menuOpenRef.current();
  };

  const onEditLinksClicked = () => {
    onJourneyShareOpen(journey);
    menuCloseRef.current();
  };

  const menuItemClasses = 'text-bedrock-p text-bedrock-black flex items-start space-x-sm text-left';

  return (
    <JourneyMenu
      placement='bottom-start'
      containerClassName='w-60 pt-md max-h-[420px] overflow-y-auto'
      openRef={menuOpenRef}
      closeRef={menuCloseRef}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={() => renderMenuOrigin(onMenuClicked)}
      footer={<div onClick={onEditLinksClicked}>Edit links</div>}
    >
      {journey.aliases.map((alias: any, index: number) => (
        <a
          key={`preview-journey-aliases-${index}`}
          href={generateJourneyAliasShareUrl(currentOrganization, alias.slug)}
          target='_blank'
          rel='noopener noreferrer'
        >
          <JourneyMenu.Item className={menuItemClasses}>
            <PreviewRegularIcon className='shrink-0' />
            <div className='text-bedrock-p'>{alias.name}</div>
          </JourneyMenu.Item>
        </a>
      ))}
    </JourneyMenu>
  );
};
